import {environment} from '../../config/environment';
import {api} from '../../shared/utils';

const baseUrl = environment.apiBaseURLClients;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });
    return query.toString();
};

export const listLicencas = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/licencas${query ? `?${query}` : ''}`);
};

export const getPlanoLicenciamentoById = (id) => api.get(`${baseUrl}/planos-licenciamento/${id}`);

// Opcionais contratados e oferecidos da assinatura (BBF-4); no portal, liberado pela visão Licenças (0105).
export const listOpcionaisDaLicenca = (id) => api.get(`${baseUrl}/licencas/${id}/opcionais`);
